export const NO_INDEX_NOFOLLOW_ROBOTS = 'noindex, nofollow, noarchive'
export const NO_INDEX_FOLLOW_ROBOTS = 'noindex, follow, noarchive'

export type RobotsMetaDescriptor = {
	name: string
	content: string
}

const NO_INDEX_PATH_PATTERN =
	/^\/(?:admin|learn|settings|login|signup|forgot-password|reset-password|onboarding|verify|legal)(?:\/|$)/

export function shouldNoIndexSitePath(pathname: string) {
	return NO_INDEX_PATH_PATTERN.test(pathname)
}

export function buildNoIndexMetaDescriptors(
	robotsContent: string = NO_INDEX_NOFOLLOW_ROBOTS,
): RobotsMetaDescriptor[] {
	return [
		{ name: 'robots', content: robotsContent },
		{ name: 'googlebot', content: robotsContent },
	]
}

export function buildNoIndexHeaders(
	robotsContent: string = NO_INDEX_NOFOLLOW_ROBOTS,
) {
	return {
		'X-Robots-Tag': robotsContent,
	}
}
